import { useNavigate } from 'react-router-dom';
import { LandingCard } from './LandingCard';
import { landingStyles } from '../landing.styles';
import { useMediaQuery } from '../hooks/useMediaQuery';

const telePacienteImage = require('../imagenes/paciente-1.jpeg');
const teleMedicoImage = require('../imagenes/medico-1.jpeg');

export const LandingFeatures = () => {
	const navigate = useNavigate();
	const isDesktop = useMediaQuery('(min-width: 768px)');

	const handlePacienteClick = () => {
		navigate('/app/login');
	};

	const handleMedicoClick = () => {
		navigate('/med/login');
	};

	return (
		<section style={landingStyles.getFeatures(isDesktop)}>
			<LandingCard
				id="paciente"
				title="Para Pacientes"
				image={telePacienteImage}
				imageAlt="Telepaciente"
				description="Encontrá especialistas disponibles, de forma simple y sin complicaciones."
				buttonText="Soy Paciente"
				onButtonClick={handlePacienteClick}
			/>
			<LandingCard
				id="medico"
				title="Para Médicos"
				image={teleMedicoImage}
				imageAlt="Telemédico"
				description="Ampliá tu alcance profesional y atendé pacientes a distancia, a través de una plataforma médica seria y simple."
				buttonText="Soy Médico"
				onButtonClick={handleMedicoClick}
			/>
		</section>
	);
};

